// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestsCard-cls1_M_4","cls2":"ResearchInterestsCard-cls2_33V ResearchInterestsCard-cls1_M_4"};